import { useQuery } from "@tanstack/react-query"
import BaseHeadline from "../../components/general/BaseHeadline"
import BasePage from "../../components/layout/BasePage"
import BaseSection from "../../components/layout/BaseSection"
import { useLocation } from "react-router-dom"

import { ReactComponent as DOWNLOAD } from "../../assets/download.svg"
import { API } from "../../api/api"
import { handleDownload } from "../../services/functions"
import { getPerson } from "./api/apiCalls"

export default function PersonPage() {
    const location = useLocation()
    const { data } = useQuery({
        queryKey: [location.pathname.replace("/", "")],
        queryFn: () => getPerson(location.pathname.replace("/", "")),
        enabled: !!location.pathname
    })

    return (
        <BasePage>
            <BaseSection classProps="px-4" flexCol>
                <BaseHeadline headline={data?.headline} />
                <div className="flex flex-col items-center justify-center gap-2 pt-24">
                    {data?.position && (
                        <div className="flex rounded-default border-2 border-secondary justify-center p-4 w-full text-secondary text-xl font-bold">
                            <p>{data?.position}</p>
                        </div>
                    )}

                    {data?.phone && (
                        <div className="flex rounded-default border-2 border-secondary justify-center p-4 w-full text-secondary text-xl font-bold">
                            <p>{data?.phone}</p>
                        </div>
                    )}
                    {data?.email && (
                        <div className="flex rounded-default border-2 border-secondary justify-center p-4 w-full text-secondary text-xl font-bold">
                            <p>{data?.email}</p>
                        </div>
                    )}
                    {data?.linkedin && (
                        <div className="flex rounded-default border-2 border-secondary justify-center p-4 w-full text-secondary text-xl font-bold">
                            <p>{data?.linkedin}</p>
                        </div>
                    )}
                    <button onClick={() => handleDownload(API.img + data?.contact?.data?.attributes?.url, "Kontakt_" + data?.name + ".vcf")}>
                        <div
                            className={`bg-primary cursor-pointer mt-4 flex w-full justify-center items-center py-3 px-8 rounded-full gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                            <p className="lowercase text-accent text-lg">Kontakt herunterladen</p>
                            <DOWNLOAD className="w-6 h-6 group-hover:translate-x-1 transition-all ease-in duration-200 pt-[2px]" />
                        </div>
                    </button>
                </div>
            </BaseSection>
        </BasePage>
    )
}
